// The server answers errors with plain English strings ({"error": "..."}).
// The admin panel is used in Russian, so known messages are translated and
// anything else falls back to a text chosen by the HTTP status.
const KNOWN_MESSAGES: Record<string, string> = {
  "login already taken": "Логин уже занят",
  "reward already selected": "Игрок уже выбрал приз",
  "reward out of stock": "Этого приза нет на складе",
  "player reward not found": "Награда не найдена",
  "reward already given": "Награда уже выдана — удалить её нельзя",
  "reward already deleted": "Награда уже удалена",
  "reward is not deleted": "Награда уже восстановлена",
  "player not found": "Игрок не найден",
  "admin only": "Недостаточно прав",
  "admin or coach only": "Недостаточно прав",
  "admin or the reward's player only": "Недостаточно прав",
  forbidden: "Недостаточно прав",
  "access denied": "Недостаточно прав",
  "account deactivated": "Учётная запись отключена",
  "file too large or invalid multipart form": "Файл слишком большой или повреждён",
  "missing file field": "Файл не передан",
  "unsupported image type": "Подойдёт только фото в JPEG, PNG, WebP или GIF",
  "password is required": "Не указан пароль",
  "invalid request body": "Некорректные данные запроса",
  "failed to list groups": "Не удалось загрузить группы",
  "failed to create group": "Не удалось создать группу",
  "failed to update group": "Не удалось сохранить группу",
  "failed to delete group": "Не удалось удалить группу",
  "failed to create chat for group": "Не удалось создать чат группы",
  "group_id and group_name are required": "Не указана группа",
  "failed to list coaches": "Не удалось загрузить тренеров",
  "failed to create coach": "Не удалось добавить тренера",
  "failed to update coach": "Не удалось сохранить тренера",
  "failed to delete coach": "Не удалось удалить тренера",
  "coach not found": "Тренер не найден",
  "failed to check password": "Не удалось проверить пароль",
  "password query parameter required": "Не указан пароль",
  "failed to list players": "Не удалось загрузить детей",
  "failed to update player": "Не удалось сохранить ребёнка",
  "failed to delete player": "Не удалось деактивировать ребёнка",
  "failed to get player attendance": "Не удалось загрузить посещаемость",
};

const registeredMessages: Record<string, string> = {};

// Each area's API module registers its own server messages, so pages built in
// parallel don't all edit this one table.
export function registerMessages(messages: Record<string, string>): void {
  Object.assign(registeredMessages, messages);
}

function textForStatus(status: number): string {
  if (status === 400) return "Некорректный запрос";
  if (status === 401) return "Нужно войти заново";
  if (status === 403) return "Недостаточно прав";
  if (status === 404) return "Не найдено";
  if (status === 409) return "Данные уже изменились — обновите страницу";
  if (status === 413) return "Файл слишком большой";
  if (status >= 500) return "Ошибка сервера";
  return "Ошибка запроса";
}

export function describeError(status: number, serverMessage?: string): string {
  const known = serverMessage
    ? KNOWN_MESSAGES[serverMessage] ?? registeredMessages[serverMessage]
    : undefined;
  return known ?? `${textForStatus(status)} (HTTP ${status})`;
}
